<template>
  <div class="review-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <MsgblContent :type="message.direction" :class="{'has-actions': actions}" >
      <MsgblTextRow>
        <div class="rating">
          <VSvgIcon tag="24" size="24" icon="review" class="review-icon" />
          <ul class="rating-stars">
            <li v-for="n in 5" :key="n">
              <VSvgIcon tag="10" :icon="n <= message.messageable.score ? 'stars_full' : 'stars_empty'" />
            </li>
          </ul>
        </div>
      </MsgblTextRow>

      <MsgblTextRow class="text">{{message.messageable.text}}</MsgblTextRow>

      <MsgblTextRow class='review-bubble-status' v-if="showStatus">
        <MsgblTextLabel>{{$t('conversation.info.status')}}:</MsgblTextLabel>
        <MsgblTextValue>{{statusValue}}</MsgblTextValue>
      </MsgblTextRow>

      <MsgblActions :actions="actions" @action="actionClicked" />
    </MsgblContent>
  </div>
</template>

<script>
import {VSvgIcon} from '@/modules/common/components'

import {
  BubbleHeader,
  MsgblContent,
  MsgblTextRow,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblActions,
} from './helpers'

export default {
  name: 'ReviewBubble',
  components: {
    VSvgIcon,
    BubbleHeader,
    MsgblContent,
    MsgblTextRow,
    MsgblTextLabel,
    MsgblTextValue,
    MsgblActions
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actionsOptions: [
        {
          "name"      : "respond",
          "name_h"   : this.$t('listings.reviews.list.respond'),
          "icon"      : "icon-Lead",
        }
      ,
        {
          "name"      : "flag",
          "name_h"   : this.$t('listings.reviews.actions.flag'),
          "icon"      : "icon-Lead",
        }
      ,
        {
          "name"      : "release",
          "name_h"   : this.$t('listings.reviews.actions.release'),
          "icon"      : "icon-Publish",
        }
      ]
    }
  },
  computed: {
    review() {
      return this.message.messageable
    },
    showStatus() {
      return this.$hasFeature("review_generation") && this.$hasFeature("yext_reviews")
    },
    statusValue() {
      return this.$t('conversation.review_statuses.' + this.review.status.toLowerCase())
    },
    actions() {
      if (!this.review.actions) return []

      return this.actionsOptions.filter(action => this.review.actions.includes(action.name))
    }
  },
  methods: {
    actionClicked(event) {
      const data = {review: this.review}
      this.$frontageApi.send('review-bubble-action', {action: event.action, data})
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';
@import '@/assets/scss/abstract/_i18n-mixins';

.review-bubble {

  .msgbl-content {
    padding: 10px 0;

    &.has-actions {
      padding-bottom: 0;
    }
  }

  .rating {
    display: flex;

    .review-icon {
      @include i-margin-mirror(0, 8px);
    }

    ul {
      margin: 0;
      padding: 0;
      display: flex;

      li {
        list-style: none;
        margin: 0 1px;
      }
    }
  }

  .text {
    margin-top: 4px;
    color: $grey-color-6;
  }

  .review-bubble-status {
    margin-top: 10px;
  }
}
</style>
